
  var _styles = {
  "loading-more__container": {
    "justifyContent": "center",
    "alignItems": "flex-start"
  },
  "loading-more__sensor": {
    "width": "100%",
    "height": "100%"
  },
  "loading-more__button": {
    "borderRadius": "0.4rem",
    "justifyContent": "center",
    "alignItems": "center"
  },
  "loading-more__button-text": {
    "fontWeight": "400",
    "color": "rgb(255,255,255)",
    "fontFamily": "PingFang SC",
    "fontSize": "0.32rem",
    "lineHeight": "0.42667rem"
  }
};



  module.exports = _styles;
  